<template>
    <v-app>
        <portal-sysbar :show-customer="false"></portal-sysbar>
        <div class="main-content">
            <portal-aside></portal-aside>
            <portal-title :title="$t('message.aside.config', { value: 'default' })">
            </portal-title>
            <portal-breadcumb></portal-breadcumb>

            <div class="content">
                <!-- Grille de modules -->
                <v-row>
                    <v-col v-for="module in modules" :key="module.name" cols="12" sm="6" md="4">
                        <v-hover v-slot="{ hover }">
                            <v-card :elevation="hover ? 8 : 2" class="module-card pa-6 d-flex flex-column"
                                :class="{ 'module-card--hover': hover }" @click="goTo(module)">
                                <div class="module-icon mb-4" :style="{ backgroundColor: module.color + '1A' }">
                                    <v-icon :color="module.color" size="28">{{ module.icon }}</v-icon>
                                </div>

                                <h3 class="text-h6 font-weight-bold mb-1">{{ module.name }}</h3>
                                <p class="text-body-2 grey--text text--darken-1 mb-4 flex-grow-1">
                                    {{ module.description }}
                                </p>

                                <div class="d-flex align-center module-link" :style="{ color: module.color }">
                                    <span class="text-body-2 font-weight-medium">Gérer</span>
                                    <v-icon small :color="module.color" class="ml-1 module-arrow">
                                        mdi-arrow-right
                                    </v-icon>
                                </div>
                            </v-card>
                        </v-hover>
                    </v-col>
                </v-row>

                <!-- État vide -->
                <div v-if="!modules.length" class="text-center py-12">
                    <v-icon size="48" color="grey lighten-1">mdi-magnify-close</v-icon>
                    <p class="grey--text mt-3 mb-0">Aucun module ne correspond à « {{ search }} »</p>
                </div>
            </div>


        </div>
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";


export default {
    title: "Administration",
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,
    },
    data() {
        return {
            loading: false,
            modules: [
                {
                    name: 'Customers',
                    description: 'Gérez vos clients, leurs coordonnées et leurs informations.',
                    icon: 'mdi-account-circle-outline',
                    color: '#1976D2',
                    route: "/config",
                },
                {
                    name: 'Users',
                    description: 'Administrez les utilisateurs, leurs rôles et leurs accès.',
                    icon: 'mdi-account-group-outline',
                    color: '#7B1FA2',
                    route: "/config/users",
                },
                {
                    name: 'Locomotives',
                    description: 'Consultez et configurez le parc de locomotives.',
                    icon: 'mdi-train-variant',
                    color: '#00796B',
                    route: "/config/locomotive",
                },
                {
                    name: 'Agreements',
                    description: 'Suivez les accords et contrats en cours avec vos partenaires.',
                    icon: 'mdi-file-document-multiple-outline',
                    color: '#E64A19',
                    route: "/config",
                },
                {
                    name: 'Assignments',
                    description: 'Organisez les affectations et la planification des ressources.',
                    icon: 'mdi-bookmark-box-multiple-outline',
                    color: '#5D4037',
                    route: "/config",
                },
                {
                    name: 'Notifications',
                    description: 'Paramétrez les alertes et les canaux de notification.',
                    icon: 'mdi-bell-outline',
                    color: '#F9A825',
                    route: "/config/notification",
                },
            ],
        }
    },
    methods: {
        goTo(module) {
            this.$router.push(module.route);
        },
    }
}
</script>

<style scoped>
.value {
    color: #7fc7b2;
    font-size: 45px;
    font-weight: bolder;
    display: block;
    bottom: 5px;
}

.config-search {
    max-width: 320px;
}

.module-card {
    height: 100%;
    cursor: pointer;
    border-radius: 12px !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.module-card--hover {
    transform: translateY(-4px);
}

.module-icon {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.module-arrow {
    transition: transform 0.2s ease;
}

.module-card:hover .module-arrow {
    transform: translateX(4px);
}
</style>